/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LostDataModal from "../../../../../../../SharedComponents/LostDataModal";
import { logoutActions } from "../../../../../../../../store/actions";
import "./CommentsForm.scss";
import NavigationButtons from "../../../../../../../SharedComponents/NavigationButtons";

const JudgmentLienAddDRPCommentsForm = ({
  updateCCBForm,
  nextFormId,
  backFormId,
  updateTempDRP,
  tempJudgmentLienDRP = {},
  updateJudgmentDisclosureDRPs,
}) => {
  const dispatch = useDispatch();
  const [showBackModal, setShowBackModal] = useState(false);
  const [comments, setComments] = useState(tempJudgmentLienDRP?.comments || "");

  const onCommentsChangeHandler = ({ target: { value } }) => {
    setComments(value);
  };

  const handleCloseBackModal = () => setShowBackModal(false);

  const isUpdated = comments?.length;

  useEffect(() => {
    if (isUpdated) {
      dispatch(
        logoutActions.setShowLogoutModal({ showLogoutModal: isUpdated })
      );
    }
  }, [isUpdated, dispatch]);

  const handleShowBackModal = () => {
    if (isUpdated) {
      setShowBackModal(true);
    } else {
      updateCCBForm(backFormId);
    }
  };

  const handleBackClick = () => {
    dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: false }));
    updateCCBForm(backFormId);
    handleCloseBackModal();
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  const handleNext = () => {
    const submitData = {
      ...tempJudgmentLienDRP,
      comments,
    };
    updateJudgmentDisclosureDRPs(submitData);
    updateCCBForm(nextFormId);
  };

  return (
    <div className="judg-lien-disclosure-comments-form-wrapper">
      <div className="judg-lien-comments-container">
        <label
          htmlFor="judgLienDisclCommentsId"
          className="comments-label"
          id="judgLienDisclCommentsLabelId"
        >
          You may use this field to provide a brief summary of the circumstances
          leading to the action as well as the current status or final
          disposition. (Optional)
        </label>
        <textarea
          id="judgLienDisclCommentsId"
          onChange={onCommentsChangeHandler}
          className={"form-control"}
          minLength={0}
          maxLength={500}
          rows="3"
          cols={500}
          value={comments}
        />
      </div>
      <NavigationButtons
        onBack={handleShowBackModal}
        onNext={handleNext}
        isLoading={false}
        nextBtnText={"Complete DRP"}
        nxtbtnid={"judgLienDisclNext"}
        bckbtnid={"judgLienDisclBack"}
      />
      <LostDataModal
        isOpen={showBackModal}
        handleClose={handleCloseBackModal}
        handleProceed={handleBackClick}
      />
    </div>
  );
};

export default JudgmentLienAddDRPCommentsForm;
